import React, { useCallback, useEffect, useMemo, useState } from "react"
import { formatDateString, formatDateTimeLocalDate } from "../../../utilities/Utils"
import NonlalinMaksudKegiatan from "../../../utilities/nonlalin/NonlalinMaksudKegiatan"
import NonlalinStatus from "../../../utilities/nonlalin/NonlalinStatus"
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap"
import { FaBars, FaEye, FaMinus, FaPlus, FaTrash } from "react-icons/fa"
import NonlalinService from "../../../services/nonlalin/NonlalinService"
import Card from "../../../components/Card"
import DataTable from "react-data-table-component"
import ModalLog from "../modal/ModalLog"
import { useNavigate } from "react-router-dom"
import ExpandableComponentNonLalin from "../expand/ExpandableComponentNonLalin"
import SweetAlert from "react-bootstrap-sweetalert"

const DaftarJasaLainnya = () => {
    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju'],
            grow: 0.4
        },
        {
            name: 'Tanggal Aju',
            cell: row => formatDateTimeLocalDate(row['tanggalAju']),
            grow: 0.3
        },
        {
            name: 'Nama',
            cell: row => row['namaTrader'],
            grow: 0.5
        },
        {
            name: 'Maksud Kegiatan',
            cell: row => <NonlalinMaksudKegiatan id={row['maksudKegiatan']} />,
            grow: 0.5
        },
        {
            name: 'Peruntukan',
            cell: row => row['peruntukan'] === '1' ? 'Konsumsi' : 'Non Konsumsi',
            grow: 0.25
        },
        {
            name: 'Tanggal Masuk Sample',
            cell: row => formatDateString(row['tanggalMasukSample']),
            grow: 0.5
        },
        {
            name: 'Status',
            cell: row => <NonlalinStatus kodeStatus={row['status']} />,
            grow: 0.3
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Permohonan</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => ViewDok(row['nomorAju'], '0')}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hapus Permohonan</Tooltip>}>
                                <Button size="sm" variant="danger" onClick={() => HapusDok(row)}>
                                    <FaTrash /> Hapus
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Permohonan</Tooltip>}>
                                <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                    <FaBars /> History
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        }
    ]

    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListData = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await nonLalinService.listNonlalinPerUptOnProcessLainnya(null, null, localStorage.getItem("kdUnit"), page, size)
            // console.log(response)
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [nonLalinService])

    useEffect(() => {
        getListData(0, 10)
    }, [getListData])

    const handleChangePage = (page) => {
        getListData(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await nonLalinService.listNonlalinPerUptOnProcessLainnya(valueSearchAju !== null ? valueSearchAju : null, null, localStorage.getItem("kdUnit"), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const handleClickReset = () => {
        setValueSearchAju('')
        getListData(0, 10)
    }

    const handleClickCari = async (page, size) => {
        const _res = await nonLalinService.listNonlalinPerUptOnProcessLainnya(valueSearchAju !== null ? valueSearchAju : null, null, localStorage.getItem("kdUnit"), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const [valueSearchAju, setValueSearchAju] = useState(null)
    const onChangeSearchAju = e => {
        setValueSearchAju(e.target.value)
    }

    const navigate = useNavigate();

    const ViewDok = (noAju, isEdit) => {
        localStorage.removeItem('isEditStorage')
        localStorage.removeItem('nomorAjuStorage')
        localStorage.setItem('nomorAjuStorage', noAju)
        localStorage.setItem('isEditStorage', isEdit)
        navigate('/nonlalin/view')
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)
    const [loadingHapus, setLoadingHapus] = useState(false)

    const HapusDok = (rowdata) => {
        setShowConfirmHapus(true)
        setRowData(rowdata)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonHapusData = { ...rowData, status: '120' }

            const response = await nonLalinService.saveNonlalinHeader(JSON.stringify(jsonHapusData))
            if (response.data.kode === '200') {
                let dataStatus = {
                    nomorAju: rowData.nomorAju,
                    kodeStatus: '120',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                setShowHapusSucces(true)
                setShowConfirmHapus(false)
            } else {
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        getListData(0, 10)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
    }

    const [rowData, setRowData] = useState(null)
    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-3">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">No. Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchAju} onChange={onChangeSearchAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari(0, 10)}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Permohonan Layanan Jasa Lainnya</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableRowsComponent={({ data }) => <ExpandableComponentNonLalin data={data} reloadList={getListData} />}
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalLog showLog={showLog} handleCloseLog={handleCloseLog} datappm={rowData} />
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Hapus, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Permohonan Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Permohonan Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}


export default DaftarJasaLainnya